import { ServiceProviderUpdateOption } from "../ServiceProviderSettingsModal/ServiceProviderSettingsModal";

export const isKeepOldValue = (option: ServiceProviderUpdateOption): option is "KEEP_OLD_VALUE" =>
    option === "KEEP_OLD_VALUE";
